import * as user from './user';

export const Api = {
  user,
};
